/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import SelectionOfAuthorizationManagement from './SelectionOfAuthorizationManagement';
import TableOfAuthorizationManagement from './TableOfAuthorizationManagement';

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
class AuthorizationManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "权限管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          权限管理
        </Typography>
        <SelectionOfAuthorizationManagement />
        <TableOfAuthorizationManagement />
      </div>
    );
  }
}

const AuthorizationManagement = observer(AuthorizationManagementInner);

AuthorizationManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AuthorizationManagement);

// for mobile template
// https://material-ui.com/store/previews/devias-kit/
// https://material-ui.com/store/previews/paperbase/
// https://demos.creative-tim.com/material-kit-react/#/